import React from 'react';
import {NavLink} from "react-router-dom";
import {INDEX_ROUTE} from "../utils/consts";

const NotFoundContent = () => {
    return (
        <div className="error_section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="error_form">
                            <h1>404</h1>
                            <h2>Упс! Мы не можем найти эту страницу.</h2>
                            <p>Возможно, она переместилась или её никогда не существовало.</p>
                            <NavLink to={INDEX_ROUTE}>Начать с главной страницы</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFoundContent;